
export const enum WorkspaceFireWallAccessEnum {
  Block = 'Block',
  Allow = 'Allow',
}

export const enum WorkspaceFireWallResourceEnum {
  DashboardView = 'DashboardView',
  DatabaseView = 'DatabaseView',
}

export type WorkspaceFireWallType = {
  ipAddresses: string[];
  accessType: WorkspaceFireWallAccessEnum;
  resources: WorkspaceFireWallResourceEnum[];
}

export type WorkspaceFireWallModel = {
  id: string;
  workspaceId: string;
  firewall: WorkspaceFireWallType;
}